import {Component, Inject, OnInit} from '@angular/core';

import {AlertService, AuthenticationService, ProjectControlItemService,} from '../../_services/index';

import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {DictionaryItem} from "../../_models/dictionaryItem";
import {DictionaryService} from "../../_services/dictionary.service";
import {LoginHelper} from "../../helpers";

@Component({
    standalone: false,
  selector: 'replace-policy-text-component',
  templateUrl: 'replace-policy-text.component.html',
  styleUrls: ['./replace-policy-text.component.css'],
})

export class ReplacePolicyTextComponent implements OnInit {
  policyForm: FormGroup;
  visibility: any = {};
  public find: string;
  public replace: string;
  public form: FormGroup;
  public message: string;

  constructor(
    public dialogRef: MatDialogRef<ReplacePolicyTextComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public authenticationService: AuthenticationService,
    public formBuilder: FormBuilder) {
  }

  ngOnInit() {
    this.policyForm = this.data.policyForm;
    this.form = this.formBuilder.group({
      find: ['', Validators.required],
      replace: [''],
    });
  }

  onReplace() {
    if (this.form.valid) {
      const policy = this.policyForm.value;
      const replaceDiv = document.createElement('div');
      let replaced = 0;
      policy.policySections.forEach(section => {
        replaceDiv.innerHTML = section.text;
        const allNodes = replaceDiv.querySelectorAll('*');
        allNodes.forEach(n => {
          n.childNodes.forEach(c => {
            if (c.nodeType === 3) {
              const parts = c.textContent.split(this.form.value.find);
              c.textContent = parts.join(this.form.value.replace);
              replaced += parts.length - 1;
            }
          });

        });
        section.text = replaceDiv.innerHTML;
      });
      this.policyForm.setValue(this.policyForm.value);
      this.message = `Replaced ${replaced} entries`;
    }
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
